import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayStr, propBool, propFunc, propNumber, propShape, propStr, } from '../../../helpers/custom-prop-types';
import Image from '../Common/Image';
import CustomSlider from '../Slider';
/**
 * スライド可能なサムネイルを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ThumbnailSlider = (props) => {
    const { className, config, images, isShowCount, setSliderRef, slideIndex } = props;
    return (_jsxs("div", Object.assign({ className: clsx('ui_thumbnail_slider', className) }, { children: [_jsx("div", Object.assign({ className: 'slider_inner' }, { children: _jsx(CustomSlider, Object.assign({ config: config, setSliderRef: setSliderRef }, { children: images.map((v) => (_jsx(Image, { allowContextMenu: false, alt: '', isObjectFit: true, src: v, useImage: true }, v))) })) })), images.length > 1 && isShowCount && (_jsx("div", Object.assign({ className: 'slider_count' }, { children: `${slideIndex + 1}/${images.length}` })))] })));
};
ThumbnailSlider.propTypes = {
    className: propStr(),
    config: propShape().isRequired,
    images: propArrayStr().isRequired,
    isShowCount: propBool().isRequired,
    setSliderRef: propFunc().isRequired,
    slideIndex: propNumber().isRequired,
};
ThumbnailSlider.defaultProps = {
    className: '',
};
export default ThumbnailSlider;
